<div>
    <div class="modal-header">
        <div class="container-fluid">
            <div class="row">
                <div class="col-lg" style="display: flex; align-items: center">
                    <div class="modal-icon icon fill-white" style="width: 35px;"
                        [inlineSVG]="'assets/ico/chart-pie.svg'" alt="icon"></div>
                    <span class="modal-title" id="modal-basic-title">

                        <span> {{'order.budget.summary.title' | translate }} </span>
                    </span>
                </div>
                <div class="modal-icon icon fill-white close-icon" (click)="close()" aria-label="close"
                    [inlineSVG]="'assets/ico/close-24px.svg'"></div>
            </div>
        </div>
    </div>
    <div class="modal-body mb-5">
        <div class="row m-0 mb-5">
            <div class="col-lg-6 title-bar greyBorder" [class.blueBorder]="selectedTab === 'products'"
                (click)="selectTab('products')">
                {{'order.budget.summary.productsAllocation' | translate |
                uppercase }}</div>
            <div class="col-lg-6 title-bar greyBorder" [class.blueBorder]="selectedTab === 'budgets'"
                (click)="selectTab('budgets')">
                {{'order.budget.summary.budgetConsumption' | translate |
                uppercase }}</div>

        </div>
        <apc-budget-summary-consumption *ngIf="selectedTab === 'budgets'" [orderId]="orderId">
        </apc-budget-summary-consumption>
        <apc-summary-modal-product-allocation *ngIf="selectedTab === 'products'" [orderId]="orderId">
        </apc-summary-modal-product-allocation>
    </div>
</div>